/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import { propTypesTextHtml } from '../../../constants/Proptypes';

const propTypesSliceText = {
  text_slice_id: PropTypes.string,
  text_content: PropTypes.shape(propTypesTextHtml),
};

export const propTypesDataText = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceText),
};
